export const state = {
  teamTaskTab: [],
  activeTab: null,
}

export const mutations = {
  ADD_TEAM_TASK_TAB(state, payload) {
    const index = state.teamTaskTab.indexOf(payload)
    if (index < 0) {
      state.teamTaskTab.push(payload)
    }
  },
  SET_ACTIVE_TAB(state, payload) {
    state.activeTab = payload
  },
  REMOVE_TAB(state, payload) {
    const index = state.teamTaskTab.indexOf(payload)
    if (index > -1) {
      state.teamTaskTab.splice(index, 1)
    }
  },
  FLUSH_TEAM_TASK(state, payload) {
    state.teamTaskTab = payload
  },
}

export const actions = {
  addTeamTaskTab({ commit }, { teamTaskTab }) {
    commit('ADD_TEAM_TASK_TAB', teamTaskTab)
  },
  setActiveTab({ commit }, { activeTab }) {
    commit('SET_ACTIVE_TAB', activeTab)
  },
  removeTab({ commit }, { indexToRemove }) {
    commit('REMOVE_TAB', indexToRemove)
  },
  flushTeamTasks({ commit }, { payload }) {
    commit('FLUSH_TEAM_TASK', payload)
  },
}
